import { render } from "./AboutUsPage.vue?vue&type=template&id=6af0ab5e&ts=true"
import script from "./AboutUsPage.vue?vue&type=script&lang=ts"
export * from "./AboutUsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__